import React, { useContext } from "react";
import { AppContext } from "../States/AppContext";

//styles
import {
  PopUpHeadingWrapper,
  PopUpIconWrapper,
  PopUpImgWrapper,
  PopUpTitle,
  PopUpTitle2,
} from "./PopUpHeading.elements";

const PopUpHeading = ({ popuppage }) => {
  const { state, setState } = useContext(AppContext);

  return (
    <>
      <PopUpHeadingWrapper>
        {state.telemetry === true && popuppage.name1 === "localaudio" && (
          <>
            <img
              src={popuppage.iconOff}
              alt=""
              style={{ objectFit: "cover", height: "25px", width: "auto" }}
            />

            <PopUpTitle>{popuppage.title} Off</PopUpTitle>
          </>
        )}

        {state.telemetry === false && popuppage.name1 === "localaudio" && (
          <>
            <PopUpIconWrapper>
              <popuppage.iconOn />
            </PopUpIconWrapper>
            <PopUpTitle>{popuppage.title} On</PopUpTitle>
          </>
        )}

        {state.ecg && popuppage.name1 === "ecg" && (
          <>
            <PopUpIconWrapper>
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <popuppage.iconOn />
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%) rotate(45deg)",
                    width: "150%",
                    height: "2px",
                    backgroundColor: "#caceca",
                  }}
                ></div>
              </div>
            </PopUpIconWrapper>
            <PopUpTitle>{popuppage.title} Off</PopUpTitle>
          </>
        )}

        {!state.ecg && popuppage.name1 === "ecg" && (
          <>
            <PopUpIconWrapper>
              <popuppage.iconOn />
            </PopUpIconWrapper>
            <PopUpTitle>{popuppage.title} On</PopUpTitle>
          </>
        )}
      </PopUpHeadingWrapper>
    </>
  );
};

export default PopUpHeading;
